import Component from './TierBanner';
import Container from './TierBanner.container';

export default Container(Component);
